import ManageFeatures from "./ManageFeatures";

export default ManageFeatures;
